import React from 'react';
import classNames from 'classnames';
import styles from './UpgradePromptPill.less';
import { Icon, IconName } from 'app/common/components/controls';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import RouterLink from 'app/common/components/singlespa/router-link';

/**
 * UpgradePromptPillProps props
 * isDarkTheme: For dark theme
 * cta: call to action of prompt, navigates user within the page
 * ctaLink: link for call to action
 * ctaTrackEvent: function expected to fire a trackUe event, fired on click of cta
 */
interface UpgradePromptPillProps {
  isDarkTheme?: boolean;
  cta: string;
  ctaLink: string;
  ctaTrackEvent?: () => void;
  iconName: IconName;
}

export const UpgradePromptPill: React.FunctionComponent<UpgradePromptPillProps> = ({
  isDarkTheme,
  cta,
  ctaLink,
  ctaTrackEvent,
  iconName,
}) => {
  const onClickCTA = () => {
    if (ctaTrackEvent) {
      ctaTrackEvent();
    }
  };

  const upgradePromptPillClasses = classNames(
    'upgrade-prompt-pill',
    styles.upgradePromptPill,
    (isDarkTheme && styles.upgradeDarkTheme) || styles.upgradeLightTheme,
    isDarkTheme && 'upgrade-prompt-pill-dark',
  );

  const LinkComponent = ctaLink === '/business-class' ? 'a' : RouterLink;

  return (
    <LinkComponent
      href={ctaLink}
      className={upgradePromptPillClasses}
      onClick={onClickCTA}
    >
      <Icon name={iconName} className={styles.upgradePromptPillIcon} small />
      <div className={styles.upgradePromptPillCTA}>{cta}</div>
    </LinkComponent>
  );
};

export const UpgradePromptPillConnected: React.FunctionComponent<UpgradePromptPillProps> = (
  props,
) => (
  <ComponentWrapper>
    <UpgradePromptPill {...props} />
  </ComponentWrapper>
);
